import {FC, useEffect, useState} from "react";
import IconToggleArrow from "../../../assets/icons/icon-toogle-arrow.svg";
import {ITypeRadar} from "../../../types";
import CardItem from "../../CardItem";
import {SidebarTab} from "../../Sidebar";
import {colors} from "../../../mocks/projectsMock";

interface IProps {
  searchDatasidebarInfo?: {
    id: string | number;
    name: string;
    clusters: {id: string | number; name: string}[];
  };
  isShowTitleParams: boolean;
  id: string | number;
  name: string;
  openSidebarWithTab: (
    tab: SidebarTab,
    directionId: number | string,
    clussterId?: number | string,
    name?: any,
    sectionName?: any,
    innerColor?: {back: string; color: string},
    nameTehnology?: string,
    idTehnology?: number | string,
    typeRadar?: ITypeRadar
  ) => void;
  typeRadar: ITypeRadar;
}

export const SidebarCardSearchStateInitiativeItem: FC<IProps> = ({
  searchDatasidebarInfo,
  isShowTitleParams,
  id: projectId,
  name: projectName,
  openSidebarWithTab,
  typeRadar,
}) => {
  const [showDirectionsBlock, setShowDirectionsBlock] = useState(true);
  const [quantitiesItemsToShow, setQuantitiesItemsToShow] = useState(10);

  useEffect(() => {
    setQuantitiesItemsToShow(10);
  }, [searchDatasidebarInfo]);

  const toggleDirectionsBlock = () => {
    setShowDirectionsBlock((prev) => !prev);
  };

  const handleShowMoreQuantitiesItem = () => {
    setQuantitiesItemsToShow((prev) => prev + 10);
  };

  const handleCardClick = (projectId: number | string, projectName: string) => {
    const color = colors.find(
      (item, index) => index === searchDatasidebarInfo?.id
    );

    openSidebarWithTab(
      SidebarTab.Projects,
      searchDatasidebarInfo?.id ?? "",
      projectId,
      projectName,
      searchDatasidebarInfo?.name,
      color ?? undefined,
      undefined,
      undefined,
      typeRadar
    );
  };
  const setColorTitle = () => {
    const colorText = colors.find(
      (item, index) => index === searchDatasidebarInfo?.id
    );
    return colorText ? colorText.back : "#fff";
  };
  return (
    <div style={{marginTop: 20}}>
      <div className="titleSearchItem" style={{}}>
        <div
          style={{
            display: "flex",
            justifyContent: "start",
            alignItems: "center",
            gap: 10,
          }}
          onClick={toggleDirectionsBlock}
        >
          <div className="toggleArrowImg">
            <img
              src={IconToggleArrow}
              alt=""
              style={{
                rotate: `${showDirectionsBlock ? "0deg" : "180deg"}`,
                transition: "all 0.3s",
              }}
            />
          </div>
          <p
            style={{
              color: setColorTitle(),
              fontSize: 16,
              fontWeight: 700,
            }}
          >
            {projectName}
          </p>
        </div>
        <div
          style={{
            backgroundColor: "#4D525B",
            borderRadius: "20px",
            width: "auto",
            padding: "0 7px",
            color: "white",
            border: "1px solid ##22272B",
            fontSize: "15px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {searchDatasidebarInfo?.clusters.length}
        </div>
      </div>
      {showDirectionsBlock && (
        <>
          {searchDatasidebarInfo?.clusters
            ?.slice(0, quantitiesItemsToShow)
            .map((item: any) => {
              return (
                <>
                  <CardItem
                    key={item.id}
                    invest_volume_tier={item.invest_volume_tier}
                    market_volume_tier={item.market_volume_tier}
                    potential_volume_tier={item.potential_volume_tier}
                    title={item.name}
                    isFlashFilterEnabled={item.growth_potential}
                    isCritical={item.critical}
                    isNational={item.national}
                    isGpb={item.gpb}
                    type={SidebarTab.Clusters}
                    onClick={() => handleCardClick(item.id, item.name)}
                    imageCard={item.image}
                    isShowTitleParams={isShowTitleParams}
                    typeRadar={typeRadar}
                  />
                </>
              );
            })}
          {quantitiesItemsToShow <
            (searchDatasidebarInfo?.clusters.length ?? 0) && (
            <span
              style={{
                color: "#0f9fff",
                padding: "5px 10px",
                cursor: "pointer",
              }}
              onClick={handleShowMoreQuantitiesItem}
            >
              Показать больше
            </span>
          )}
        </>
      )}
    </div>
  );
};
